var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 30,
    viewBox: "0 0 38 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Interface / Credit_Card_01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 13V22.6004C1 24.8406 1 25.9602 1.43598 26.8158C1.81946 27.5684 2.43094 28.181 3.1836 28.5644C4.0384 29 5.15798 29 7.39382 29H30.6062C32.842 29 33.96 29 34.8148 28.5644C35.5674 28.181 36.181 27.5684 36.5644 26.8158C37 25.961 37 24.843 37 22.6072V13M1 13V9M1 13H37M37 13V9M1 9V7.4004C1 5.16018 1 4.03924 1.43598 3.1836C1.81946 2.43094 2.43094 1.81946 3.1836 1.43598C4.03924 1 5.16018 1 7.4004 1H30.6004C32.8406 1 33.9592 1 34.8148 1.43598C35.5674 1.81946 36.181 2.43094 36.5644 3.1836C37 4.0384 37 5.15798 37 7.39382V9M1 9H37M9 21H17",
    stroke: "#D3D3D3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.cea8f81cb39c76713afd2ce47d5cde39.svg";
export { ForwardRef as ReactComponent };